import { useTranslation } from "react-i18next";
import { useFieldQueue } from "../hooks/useFieldQueue";
import { discardQueuedCheck } from "../services/fieldOffline";

// App-wide banner for well checks saved without signal. Hidden when the
// queue is empty. Pending checks upload on their own (useFieldQueue);
// checks the server rejected stay listed until the pumper dismisses them.
export default function OfflineQueueBanner({ token }) {
  const { t } = useTranslation();
  const { queue, pendingCount, failed, online, flush } = useFieldQueue(token);
  if (pendingCount === 0 && failed.length === 0) return null;
  // Rig reports share the queue — word the banner for "items" when any
  // pending item isn't a well check.
  const mixed = queue.some((c) => c.status === "pending" && c.kind && c.kind !== "wellCheck");

  const base = {
    position: "sticky",
    top: 0,
    zIndex: 1000,
    padding: "10px 16px",
    fontSize: "13px",
    fontWeight: "700",
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    alignItems: "center",
    justifyContent: "space-between",
  };
  const btn = {
    minHeight: "40px",
    padding: "0 12px",
    borderRadius: "6px",
    background: "none",
    fontWeight: "700",
    fontSize: "12px",
    cursor: "pointer",
  };

  return (
    <div data-testid="offline-queue-banner">
      {pendingCount > 0 && (
        <div role="status" style={{ ...base, backgroundColor: "#2a2000", color: "#ffcc44", borderBottom: "1px solid #ffaa0066" }}>
          <span>
            {mixed
              ? online
                ? t("offline.uploadingItems", { count: pendingCount })
                : t("offline.savedOfflineItems", { count: pendingCount })
              : online
                ? t("offline.uploading", { count: pendingCount })
                : t("offline.savedOffline", { count: pendingCount })}
          </span>
          {online && (
            <button type="button" onClick={flush} style={{ ...btn, color: "#ffcc44", border: "1px solid #ffaa0088" }}>
              {t("offline.retryNow")}
            </button>
          )}
        </div>
      )}
      {failed.map((c) => (
        <div key={c.key} role="alert" style={{ ...base, backgroundColor: "#2a0010", color: "#ff8899", borderBottom: "1px solid #ff446666" }}>
          <span>
            {c.kind === "rigReport"
              ? t("offline.rejectedReport", { label: c.wellName || "?" })
              : c.kind === "hydroTicket"
                ? t("offline.rejectedTicket", { label: c.wellName || "?" })
                : t("offline.rejected", { well: c.wellName || "?" })}{" "}
            {c.lastError}
          </span>
          <button type="button" onClick={() => discardQueuedCheck(c.key)} style={{ ...btn, color: "#ff8899", border: "1px solid #ff446688" }}>
            {t("offline.dismiss")}
          </button>
        </div>
      ))}
    </div>
  );
}
